import { ChangeEvent, useEffect, useRef, useState } from 'react';
import WidgetCard from './WidgetCard';
import '../../css/RecordingWidget.css';
import { Subscriber } from '../../services/Ros/Subscriber';
import { TRANSFORM } from '../../constants/topics';
import { useFetch } from '../../services/Requests/useFetch';
import { useScreenSize } from '../../services/General/ScreenResolutionProvider';
import { useRealtimeUpdates } from '../../services/Requests/websocket';
import { useShortcutsStatus } from '../../services/General/KeyboardShortcutProvider';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useRobotDetails } from '../../utilities/RobotDetailsContext';
import { useNearestBusStop } from '../../components/PathPlanning/NearestBusStop';
import { getNextStopNumber, StopData } from '../../components/ZoneTravel/StopTravelBody';



interface IRecordMission {
    t: string;
}


const options: RequestInit = {
    method: "GET"
}

interface IUpdateMessage { 
    id: number | string;
    prog: number;
    length: number;
    run: boolean;
    start_time?: string | null | undefined;
    return_code?:string;
}



interface RecordingWidgetProps {
    isManualModeActive: boolean;
}

export const SimpleRecordingWidget = ({ isManualModeActive }: RecordingWidgetProps) => {
    const {robotDetails} = useRobotDetails();
    const { width } = useScreenSize();
    const [ returnCode, setReturnCode ] = useState<string>("None")
    const [recordingState, setRecordingState] = useState(false);
    const [processing, setProcessing] = useState(false);
    const [currentStop, setCurrentStop] = useState(1);
    const [nextStop, setNextStop] = useState(2);
    const [nextStopString, setNextStopString] = useState('002');
    const [isHomeSet, setisHomeSet] = useState(false);
    const [assetName, setAssetName] = useState('');
    const [assets, setAssets] = useState<string[]>([])
    const [existingAsset, setExistingAsset] = useState<boolean>(false)
    const nearestStop = useNearestBusStop(0.001)

    const stopDataRef = useRef<StopData[]>([]);

    const fetchStopData = useFetch<StopData[]>('/api/missions/get_stops_data', options);

    const [selectedStop, setSelectedStop] = useState(''); // New state for selected stop
    const { setEnabled }= useShortcutsStatus();
    const recordingStateRef = useRef(recordingState);
    const nextStopRef = useRef(nextStop);
 
    const { ws} = useRealtimeUpdates();                                                         //Get the live updates websocket from the context provider.
    const socket = ws

    useEffect(() => {
        fetchStopData.get();
        return () => {
            fetchStopData.abortRequest && fetchStopData.abortRequest();
        };
    }, []);

    useEffect(() => {
        const { state: { status, data } } = fetchStopData;
        if (status === 'fetched' && data && data.length > 0) {
            stopDataRef.current = data;
            setNextStopString(getNextStopNumber(data))
        }
    }, [fetchStopData.state]);

    const savePoint = useFetch<IRecordMission>('/api/missions/save_point',options)
    const setAsset = useFetch<IRecordMission>('/api/missions/set_asset', options);
    const zoneStops = useFetch<string[]>('/api/missions/get_stops', options); // Gets a list of available stops when given {zone: zone} params
    const getZones = useFetch<string[]>('/api/missions/get_zones', options); // Gets a list of available zones
    const getAssets = useFetch<string[]>('/api/missions/get_assets', options); 

    let position = 'widget-top-left';

    if (width <= 1024) {
        position = 'widget-top-left';
    }

    const handleNameChange = (e: ChangeEvent<HTMLInputElement>) => {
        let newAsset =   e.target.value
        .replace(/\s+/g, '') // Remove whitespace
        .replace(/[<>:"/\\|?*\x00-\x1F]/g, '') // Remove illegal characters for Windows
        .replace(/\.+$/, '') // Remove trailing periods (Windows restriction)
        .replace(/CON|PRN|AUX|NUL|COM[1-9]|LPT[1-9]/gi, '') // Remove reserved filenames
        
        if (newAsset.endsWith("WD") || newAsset.endsWith("LQ")){
            newAsset = newAsset.slice(0, -2);
        }
        
        
        if (assets.includes(newAsset)){
            setExistingAsset(true)
        }else{
            setExistingAsset(false)
        }

        if (newAsset !== ''){
            setEnabled(false)
        }else{
            setEnabled(true)
        }

        setAssetName(
            newAsset
          );

    }


    const handleGetZones = () => {
        getZones.get();     // Performs a get request to get available zones.
        console.log('Got Zones');
    };

    const handleGetAssets = () => {
        getAssets.get();     // Performs a get request to get available zones.
        console.log('Got Assets');
    };

    const handleMessage = (running:boolean,rc:string | null | undefined) =>{
        console.log(`Running: ${running}, Return Code: ${rc}`)
        console.log(`Next: ${nextStopRef.current}`)
        
        console.log(returnCode)
        if (running){
            if (rc==='r0'){
                console.log("recording Failed to Start")

                setRecordingState(false)
                setEnabled(false)
            }
            else if (rc==='r1'){
                console.log("error during recording a")
                setRecordingState(false)
                setEnabled(false)

            }else if (rc==='s1'){
                console.log("Error while Saving")
                setRecordingState(true)
                setEnabled(true)
            }
            else if (rc==='s0'){
                console.log("Error while not Saving")
                console.log(currentStop,selectedStop)
                setRecordingState(false)
                setEnabled(false)
            }
           
        }else{
            if (rc==='r0'){
                console.log("recording Failed to Start")
                setRecordingState(false)
                setEnabled(false)
            }
            else if (rc==='r1'){
                console.log("error during recording")

                setRecordingState(false)
                setEnabled(false)
            }else if (rc==='s1'){
                console.log("Error while Saving")
                setRecordingState(true)
                setEnabled(true)
            }else if (rc==='s0'){
                console.log("Error while not Saving")
                console.log(currentStop,selectedStop)
                setRecordingState(false)
                setEnabled(false)
            }
            else{
                console.log(recordingState)
                
            }
        }
        if (rc==='complete'){
            console.log("not running, set next stop")
            setCurrentStop(nextStopRef.current)
            setSelectedStop(`stop${nextStopRef.current}`);
            setNextStop(nextStopRef.current + 1)
            setEnabled(false)
            
        }
        if (rc !== 'start'){
            setProcessing(false)
        }
    }

    useEffect(() => {

        console.log(`Changed Next Stop ${nextStop}`)
        nextStopRef.current = nextStop;

    }, [nextStop]);


    /**
     * Receives live update messages from the NOTIFY function on the postgres database for mission plans.
     * Listens for a message containing id of the mission plan, current progress, and whether the mission is still running.
     * @param message The message received by the websocket
     */
    const onSocketMessage = (message : MessageEvent) => {
        const data : IUpdateMessage = JSON.parse(message.data);
        console.log(data)
        if (data.id==="Recording"){
            handleMessage(data.run,data.return_code)

            setReturnCode(data.return_code ?? "None")
        }else{
            setReturnCode(data.return_code ?? "None")
            if (data.return_code!=="start" && data.return_code!=="message" && data.return_code!=="complete"){
            }
        }
        
    };

    /**
     * Runs when the notification websocket, active index or missionInfo object are changed.
     * Responsible for adding a websocket message listener to listen for the live updates from the database.
     */
    useEffect(() => {

        socket.addEventListener('message', onSocketMessage);

        //Cleanup. Removes listener when this component is destroyed.
        return () => {
            socket.removeEventListener('message', onSocketMessage);
        }

    }, [socket]);

    useEffect(() => {
        const { status, data } = zoneStops.state;

        if (status === 'fetched') {
            if (data) {
                // Set data as available stops minus the final stop
                console.log(data.slice(0, -1))
            }
        }
    }, [zoneStops.state.data]);

    useEffect(() => {
        const { status, data } = getZones.state;

        if (status === 'fetched') {
            if (data) {
                // Set data as available zones minus zone0
                console.log(data)
                if ('zone0' in data){
                    setisHomeSet(true)
                }
            }
        }
    }, [getZones.state.data]);

    useEffect(() => {
        const { status, data } = getAssets.state;

        if (status === 'fetched') {
            if (data) {
                // Set data as available zones minus zone0
                console.log(data)
                setAssets(data);
            }
        }
    }, [getAssets.state.data]);

    useEffect(() => {
        console.log(`Recording State Change ${recordingState}`)
        recordingStateRef.current = recordingState;
    }, [recordingState]);

    useEffect(() => {
        const { status,  } = getAssets.state;

        if (status === 'fetched') {
            setProcessing(false)
            setEnabled(true)
        }else if (status === 'fetching'){
            setProcessing(true)
            setEnabled(false)
        }else{
            setProcessing(false)
            setEnabled(true)
        }
        

    }, [savePoint]);

    const handleAddHomePoint = () => {
        const path = `/home`;
        const paths = `home,/${path}`;
        const stops = `home,${path},home`;
        console.log(paths);
        savePoint.get([{ param: 'mission', value: 1 },
                        { param: 'host', value: robotDetails.rosHostname },
                        { param: 'port', value: robotDetails.rosPort },
                        { param: 'path_name', value: paths },
                        { param: 'stops', value: stops },
                        { param: 'zone', value: "zone0" }]);     // Performs a get request with the mission plan id as a query param.
        console.log('Home Point Saved');
        setEnabled(true)
    }

    const handleAddPoint = () => {
        const path = `/${nextStopString}`;
        const paths = `point,/${path}`;
        const stops = `${nextStopString},${path},${nextStopString}`;
        console.log(paths);
        savePoint.get([{ param: 'mission', value: 1 },
                        { param: 'host', value: robotDetails.rosHostname },
                        { param: 'port', value: robotDetails.rosPort },
                        { param: 'path_name', value: paths },
                        { param: 'stops', value: stops },
                        { param: 'zone', value: "zone1" }]);     // Performs a get request with the mission plan id as a query param.
        console.log('Home Point Saved');
        setEnabled(true)
    }

    const handleSubmitAsset = () => {
        if (nearestStop){
            console.log(`Asset '${assetName}' submitted for ${nearestStop}`);
            setAsset.get([{ param: 'mission', value: 1 },
                      { param: 'host', value: robotDetails.rosHostname },
                      { param: 'port', value: robotDetails.rosPort },
                      { param: 'asset', value: assetName },
                      { param: 'stop', value: nearestStop.stop },
                      { param: 'zone', value: nearestStop.zone }]);
        // console.log('Testing recorded path', routeAssets);
            setAssetName('');
            setAssets((prevAssets) => [...prevAssets,assetName])
        }
        else{
            handleAddPoint()
            console.log(`Asset '${assetName}' submitted for ${selectedStop}`);
        }
        
        // handleZeroPTZ();
    };


    useEffect(() => {
        handleGetZones(); // Fetch available zones on component mount
        handleGetAssets(); // Fetch avalable Assets on component mount
        return () => {
            console.log("Unmount RW")
        }
    }, []);

    // const isZoneExisting = avaliableZones.includes(pathName);

    return (
        <Subscriber name={TRANSFORM.name} type={TRANSFORM.type} rate={TRANSFORM.throttle}>
            <WidgetCard position={position}>
                <WidgetCard.Header>
                    Recording Control
                </WidgetCard.Header>
                <WidgetCard.Body>
                    <div className="recording-control-box">
                        <button
                            type="button"
                            className={`form-control btn ${!isHomeSet ?  'btn-success' : 'btn-danger' }`}
                            onClick={handleAddHomePoint}
                            disabled={processing}
                        >
                            {!isHomeSet ? 'Set Home Point' : 'Change Home Point'}
                        </button>

                            <OverlayTrigger
                                placement= 'right-start'
                                show={existingAsset}
                                overlay={
                                    <Tooltip id="tooltip-email">
                                        Asset already exists.
                                    </Tooltip>
                                }
                            >
                                <input
                                    type="text"
                                    className="form-control"
                                    value={assetName}
                                    onChange={handleNameChange}
                                    disabled={processing}
                                    placeholder="Enter asset name"
                                />
                            </OverlayTrigger>
                            <OverlayTrigger
                                placement= 'right-start'
                                // show={existingAsset}
                                overlay={
                                    <Tooltip id="tooltip-email">
                                        {nearestStop ? 'Save current Asset' : 'Saves Current Position and Asset'}
                                    </Tooltip>
                                }
                            >
                                <button
                                    type="button"
                                    className="btn btn-success"
                                    onClick={handleSubmitAsset}
                                    disabled={existingAsset || processing || assetName==''}
                                >
                                    {nearestStop ? 'Save Asset' : 'Save Stop & Postion'}
                                </button>
                            </OverlayTrigger>
                        </div>
                </WidgetCard.Body>
            </WidgetCard>
        </Subscriber>
    );
};
